export const MAP_ZOOM_DEFAULT = 1;
export const MAP_ZOOM_MIN = 0.5;
export const MAP_ZOOM_MAX = 6;

export const clampMapZoom = (value) => {
  if (!Number.isFinite(value)) {
    return MAP_ZOOM_DEFAULT;
  }

  if (value < MAP_ZOOM_MIN) {
    return MAP_ZOOM_MIN;
  }

  if (value > MAP_ZOOM_MAX) {
    return MAP_ZOOM_MAX;
  }

  return value;
};

/**
 * Keeps a point in viewport coordinates stationary while changing map scale.
 * The map layers use a centered CSS transform origin, so both the anchor and
 * pan values are expressed relative to the center of the untransformed map
 * viewport (rather than its top-left corner).
 */
export const calculateAnchoredPan = ({
  anchor,
  previousAnchor = anchor,
  pan,
  oldScale,
  newScale,
}) => {
  const safeOldScale = Number(oldScale);
  const safeNewScale = Number(newScale);
  const anchorX = Number(anchor?.x);
  const anchorY = Number(anchor?.y);
  const previousAnchorX = Number(previousAnchor?.x);
  const previousAnchorY = Number(previousAnchor?.y);
  const panX = Number(pan?.x);
  const panY = Number(pan?.y);

  if (
    !Number.isFinite(safeOldScale) ||
    safeOldScale <= 0 ||
    !Number.isFinite(safeNewScale) ||
    safeNewScale <= 0 ||
    !Number.isFinite(anchorX) ||
    !Number.isFinite(anchorY) ||
    !Number.isFinite(previousAnchorX) ||
    !Number.isFinite(previousAnchorY) ||
    !Number.isFinite(panX) ||
    !Number.isFinite(panY)
  ) {
    return pan;
  }

  const worldX = (previousAnchorX - panX) / safeOldScale;
  const worldY = (previousAnchorY - panY) / safeOldScale;

  return {
    x: anchorX - worldX * safeNewScale,
    y: anchorY - worldY * safeNewScale,
  };
};

// Kept as the public desktop-oriented name for existing callers. The shared
// implementation also supports a moving anchor (the midpoint of a pinch).
export const calculateCursorAnchoredPan = (options) => calculateAnchoredPan(options);

export default clampMapZoom;
